import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-component p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-col-3" }
const _hoisted_3 = { style: {"font-size":"1rem"} }
const _hoisted_4 = { class: "p-field p-input-filled p-col-9" }
const _hoisted_5 = {
  key: 0,
  class: "p-error"
}
const _hoisted_6 = { class: "p-col-3" }
const _hoisted_7 = { style: {"font-size":"1rem"} }
const _hoisted_8 = { class: "p-field p-input-filled p-col-9" }
const _hoisted_9 = { class: "p-col-3" }
const _hoisted_10 = { style: {"font-size":"1rem"} }
const _hoisted_11 = { class: "p-field p-input-filled p-col-9" }
const _hoisted_12 = { class: "p-col-3" }
const _hoisted_13 = { style: {"font-size":"1rem","cursor":"help"} }
const _hoisted_14 = { class: "p-col-9" }
const _hoisted_15 = { class: "p-field p-input-filled p-inputgroup" }
const _hoisted_16 = { class: "p-col-3" }
const _hoisted_17 = { style: {"font-size":"1rem","cursor":"help"} }
const _hoisted_18 = { class: "p-field p-input-filled p-col-9" }
const _hoisted_19 = { class: "p-col-3" }
const _hoisted_20 = { style: {"font-size":"1rem"} }
const _hoisted_21 = { class: "p-field p-input-filled p-col-9" }
const _hoisted_22 = { class: "p-inputgroup" }
const _hoisted_23 = {
  key: 0,
  class: "p-inputtext p-component region-display region-display--set"
}
const _hoisted_24 = {
  key: 1,
  class: "p-inputtext p-component region-display region-display--unset"
}
const _hoisted_25 = { class: "p-col-3" }
const _hoisted_26 = { style: {"font-size":"1rem"} }
const _hoisted_27 = { class: "p-field p-input-filled p-col-9" }
const _hoisted_28 = { class: "p-col-3" }
const _hoisted_29 = { style: {"font-size":"1rem"} }
const _hoisted_30 = { class: "p-field p-input-filled p-col-9" }
const _hoisted_31 = { class: "p-col-3" }
const _hoisted_32 = { class: "inner-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_FormHeadTrainingTable = _resolveComponent("FormHeadTrainingTable")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.trainingKey.description), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_InputText, {
          type: "text",
          modelValue: _ctx.trainingKey.value.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.trainingKey.value.value) = $event)),
          disabled: ""
        }, null, 8, ["modelValue"]),
        (!(_ctx.trainingKey.value.value !== '' && _ctx.trainingKey.value.value !== null))
          ? (_openBlock(), _createElementBlock("small", _hoisted_5, _toDisplayString(_ctx.$t("Squeeze.Training.TrainingKey")), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('Squeeze.Training.Region') + ' ' + _ctx.$t('Squeeze.Training.Anchor')), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_Dropdown, {
          modelValue: _ctx.regionAnchorId,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.regionAnchorId) = $event)),
          options: _ctx.allRegionAnchors,
          optionLabel: _ctx.getTranslatedDescription,
          optionValue: "id",
          onChange: _ctx.getHeadFields
        }, null, 8, ["modelValue", "options", "optionLabel", "onChange"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("Squeeze.DocumentClasses.Field")), 1)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_Dropdown, {
          modelValue: _ctx.headField.fieldId,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.headField.fieldId) = $event)),
          options: _ctx.documentFields,
          optionLabel: _ctx.getTranslatedDescription,
          optionValue: "id",
          filter: true,
          autoFilterFocus: true,
          loading: _ctx.loading,
          onShow: _ctx.showDropdownOverlay
        }, null, 8, ["modelValue", "options", "optionLabel", "loading", "onShow"])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_13, [
          _createTextVNode(_toDisplayString(_ctx.$t("Squeeze.Locators.Value")), 1)
        ])), [
          [
            _directive_tooltip,
            _ctx.headField.locatorId ? _ctx.$t('Squeeze.Training.OptionalFallback') : _ctx.$t('Squeeze.Training.Optional'),
            void 0,
            { top: true }
          ]
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_InputText, {
            type: "text",
            modelValue: _ctx.headField.valuePattern,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.headField.valuePattern) = $event)),
            placeholder: _ctx.$t('Squeeze.Locators.Value'),
            onFocus: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onFocusField('headFieldValuePattern')))
          }, null, 8, ["modelValue", "placeholder"]),
          _createVNode(_component_Button, {
            class: "active",
            icon: "mdi mdi-auto-fix",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onFocusField('headFieldValuePattern')))
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_17, [
          _createTextVNode(_toDisplayString(_ctx.$t("Squeeze.Training.Locator")), 1)
        ])), [
          [
            _directive_tooltip,
            _ctx.$t('Squeeze.Training.Optional'),
            void 0,
            { top: true }
          ]
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_Dropdown, {
          modelValue: _ctx.headField.locatorId,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.headField.locatorId) = $event)),
          options: _ctx.allLocators,
          optionLabel: "description",
          optionValue: "id",
          showClear: true,
          placeholder: _ctx.$t('Squeeze.Training.SelectLocator')
        }, null, 8, ["modelValue", "options", "placeholder"])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.$t("Squeeze.Training.Region")), 1)
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          (_ctx.regionBadge)
            ? (_openBlock(), _createElementBlock("span", _hoisted_23, "✓ " + _toDisplayString(_ctx.regionBadge), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.$t('Squeeze.Training.RegionNotSet')), 1)),
          _createVNode(_component_Button, {
            icon: "mdi mdi-vector-rectangle",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onFocusField('headFieldValueRegion')))
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.$t("Squeeze.Training.IgnoreSpaces")), 1)
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createVNode(_component_Dropdown, {
          modelValue: _ctx.headField.valueIgnoreWhitespace,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.headField.valueIgnoreWhitespace) = $event)),
          options: _ctx.booleanOptions,
          optionLabel: "name",
          optionValue: "id"
        }, null, 8, ["modelValue", "options"])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.$t("Squeeze.Training.MultilineReadout")), 1)
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createVNode(_component_Dropdown, {
          modelValue: _ctx.headField.accumulateFoundValues,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.headField.accumulateFoundValues) = $event)),
          options: _ctx.booleanOptions,
          optionLabel: "name",
          optionValue: "id"
        }, null, 8, ["modelValue", "options"])
      ]),
      _createElementVNode("div", _hoisted_31, [
        _withDirectives((_openBlock(), _createElementBlock("span", null, [
          _createVNode(_component_Button, {
            label: _ctx.headField.id ? _ctx.$t('Squeeze.Training.Retrain') : _ctx.$t('Squeeze.Training.Train'),
            disabled: !_ctx.canTrain,
            onClick: _ctx.trainHeadField
          }, null, 8, ["label", "disabled", "onClick"])
        ])), [
          [
            _directive_tooltip,
            !_ctx.canTrain ? _ctx.$t('Squeeze.Training.PatternOrLocatorRequired') : null,
            void 0,
            { top: true }
          ]
        ])
      ])
    ]),
    _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
    _createElementVNode("div", _hoisted_32, [
      _createVNode(_component_FormHeadTrainingTable, {
        tableOrigin: "headFields",
        tableData: _ctx.allHeadFields,
        loading: _ctx.loading,
        documentFields: _ctx.documentFields,
        onChangeData: _ctx.changeHeadField,
        onDeleteData: _ctx.deleteHeadField,
        onOnMarkRegion: _ctx.onMarkRegion
      }, null, 8, ["tableData", "loading", "documentFields", "onChangeData", "onDeleteData", "onOnMarkRegion"])
    ])
  ], 64))
}